(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cansweet-newsletter-confirmation"] && !Shopify.designMode) return;
  try {
    (() => {
    const showNewsletterConfirmation = () => {
      const success = document.querySelector('[data-cs-newsletter-success]');
      const dialog = document.querySelector('.cs-newsletter-confirmation');
      if (!success || !dialog || typeof dialog.showModal !== 'function') return;
      dialog.addEventListener('close', () => success.focus(), { once: true });
      dialog.showModal();
      dialog.querySelector('button').focus({ preventScroll: true });
      const url = new URL(window.location.href);
      if (url.searchParams.get('customer_posted') === 'true') {
        url.searchParams.delete('customer_posted');
        window.history.replaceState(window.history.state, '', url);
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showNewsletterConfirmation, { once: true });
    } else {
      showNewsletterConfirmation();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
